var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.buttons),function(button,index){return _c('span',{key:index,staticClass:"table-action__container"},[(
        (button.showCondition && button.showCondition(_vm.row)) ||
        !button.showCondition
      )?_c('TableActionButton',{attrs:{"label":_vm.$t(`tableButtons.${_vm.getButtonName(button)}`),"button-icon":button.secondaryIcon ? button.secondaryIcon(_vm.row) : button.icon,"disabled":button.disableCondition ? button.disableCondition(_vm.row) : false,"click-function":() => {
          if (!(button.disableCondition && button.disableCondition(_vm.row))) {
            _vm.$emit('actionClick', _vm.getButtonName(button));
          }
        }}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }